import React from 'react';
import { Checkbox, Form } from 'antd';

const Visible = () => {
    return (
        <Form.Item name="visible" valuePropName="checked">
            <Checkbox>Widoczna w wyszukiwarce</Checkbox>
        </Form.Item>
    );
};

export default Visible;
